import * as angular from "angular";

export class BillingOrderDialogService {

  constructor(private $mdDialog, private $log) {
  }

  editInvoiceConfiguration(preferences, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      templateUrl: 'app/modules/billing-accounts/views/dialog-views/edit-invoice-configuration-dialog.html',
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog, billingAccountsRequests, $log) {
        $scope.loading = false;

        $scope.cancel = $mdDialog.cancel;
        //////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.preferences = angular.copy(preferences);

        //////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.preferences)
            }
          } else {
            self.$log.error("Form validation error");
            // this.$log.error('Form resolved to undefined!. \n' +
            //   '--> pre  @submit')
          }
        }

      }
    });

  }

  editEdiPreferences(preferences) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialog-views/edit-edi-settings-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog, billingAccountsRequests, $log) {
        $scope.loading = false;

        $scope.cancel = $mdDialog.cancel;
        //////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.preferences = angular.copy(preferences);

        //////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.preferences)
            }
          } else {
            self.$log.error("Form validation error");
            // this.$log.error('Form resolved to undefined!. \n' +
            //   '--> pre  @submit')
          }
        }

      }
    });

  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingOrderDialogService', BillingOrderDialogService);
